<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="container">
            <nav-bar-box :extr="navData"></nav-bar-box>
            <section v-if="listData.length > 0">
                <div class="list_box1">
                    <!-- <h4>原材成本汇总表</h4> -->
                    <table border>
                        <thead>
                            <tr>
                                <th>品种</th>
                                <th>数量(吨)</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="list_box">
                    <!-- <h4>原材成本汇总表</h4> -->
                    <table border>
                        <tbody class="table_body_box">
                            <template v-for="(item, index) in listData">
                                <tr :key="`cost_${index}`" :class="{tr_shallow: index % 2 === 0, tr_deep: index % 2 !== 0}">
                                    <td align="center">
                                        {{ item.group_name }}
                                    </td>
                                    <td align="center">
                                        {{ item.sales_volume }}
                                    </td>
                                </tr>
                            </template>
                            <div class="border_div"></div>
                        </tbody>
                    </table>
                </div>
            </section>
            <div v-else class="no_data"></div>
        </div>
    </v-touch>
</template>

<script>
export default {
    data() {
        return {
            navData: {
                title: '销售日报表',
                leftText: '',
                rightText: '',
                leftArrow: true,
                leftCallBack: this.onClickLeft,
            },
            listData: [],
        };
    },
    created() {
        this.listData = JSON.parse(this.$route.query.tableData);
    },
    methods: {
        // 返回上级页面
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/salesDaily', query: {
                date: this.$route.query.date,
            } });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/salesDaily', query: {
                date: this.$route.query.date,
            } });
        },
    },
};
</script>

<style lang="stylus">
.container
    width 100%
    height 100%
    section
        height 100%
        .list_box1
            width 100%
            margin 12rpx 12rpx 0 12rpx
            height 36rpx
            table
                width calc(100% - 24rpx)
                border-collapse collapse
                border-color #f4f4f4
                max-height 100%
                thead
                    background #FBEEEE
                    border-bottom 1px solid #bebebe
                .table_body_box
                    height calc(100% - 60rpx)
                    overflow-y scroll
                tr
                    width 100%
                    display flex
                    border-color #f4f4f4
                    height 36rpx
                    line-height 32rpx
                    th:last-child
                        border-right 1px solid #9d9d9d
                    td:last-child
                        border-right 1px solid #9d9d9d
                    th
                        font-weight 540
                        color #000
                    th, td
                        width 50%
                        border-color #f4f4f4
                .tr_shallow
                    background #ffffff
                .tr_deep
                    background #F9FAFD
        .list_box
            width 100%
            margin 0 0 12rpx 12rpx
            max-height calc(100% - 125rpx)
            overflow: auto;
            table
                width calc(100% - 24rpx)
                border-collapse collapse
                border-color #f4f4f4
                max-height 100%
                thead
                    background #FBEEEE
                .noData
                    width 100%
                .border_div
                    width 100%
                    height 1px
                    background #d0d0d0;
                tr
                    width 100%
                    display flex
                    border-color #f4f4f4
                    height 36rpx
                    line-height 36rpx
                    th:last-child
                        border-right 1px solid #9d9d9d
                    td:last-child
                        border-right 1px solid #9d9d9d
                    th
                        font-weight 540
                        color #000
                    th, td
                        width 50%
                        border-color #f4f4f4
                .tr_shallow
                    background #ffffff
                .tr_deep
                    background #F9FAFD
</style>
